import { Link } from '@tanstack/react-router';

import { useSlate } from 'slate-react';
import { NavbarPortal } from 'app/components';
import logo from 'app/images/Xplir_logo_icon.svg';
import { useUser } from 'app/state/contexts/UserContext';

interface NavbarOrganization {
  id: number;
  name?: string;
}

interface NavbarUser {
  firstName: string;
  lastName: string;
}

interface NavbarTemplateEditorProps {
  document: { superId: number | string; name?: string };
  template: { name?: string } | null;
}

export const NavbarTemplateEditor = ({ document, template }: NavbarTemplateEditorProps) => {
  const editor = useSlate();
  const { organizations, selectedOrganization, user } = useUser();
  const org = (organizations as NavbarOrganization[] | undefined)?.find((o) => o.id === selectedOrganization);
  const currentUser = user as NavbarUser | undefined;
  return (
    <NavbarPortal fullWidth>
      <div className="navbar--editor">
        <div className="logo">
          <img alt="logo" src={logo} />
        </div>
        <Link className="navigation" to="/documents/$documentId/design" params={{ documentId: String(document.superId) }}>
          <button className="button--small clear">
            <i className="fa-regular fa-chevron-left" />
          </button>
        </Link>
        <div className="project">
          <Link className="me-3" to="/documents/$documentId" params={{ documentId: String(document.superId) }}>
            <p className="sub-heading mb-1">{`${org?.name || ''} > ${document.name}`} </p>
            <div className="d-flex align-items-center">
              <h4>{template?.name} </h4>
              <span className="ms-3 text-gray-900 fs-7"></span>
            </div>
          </Link>
        </div>
        <div className="controls">
          <button
            className="button--small clear"
            onClick={() => {
              editor.undo();
            }}
          >
            <i className="fa-regular fa-arrow-rotate-left" />
          </button>
          <button
            className="button--small clear"
            onClick={() => {
              editor.redo();
            }}
          >
            <i className="fa-regular fa-arrow-rotate-right" />
          </button>
          <div className="navbar-user-icon-wrapper border--left">
            <div className="user--circle">
              {currentUser?.firstName.charAt(0).toUpperCase() || 'N'}
              {currentUser?.lastName.charAt(0).toUpperCase() || 'A'}
            </div>
          </div>
          <div className="navbar-notification-icon-wrapper">
            <i className="fa-regular fa-bell"></i>
          </div>
        </div>
      </div>
    </NavbarPortal>
  );
};
